"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
const materialsData = [{
  material: "true phenolic",
  bestFor: "Control panels, MIL-SPEC, dielectric needs",
  products: "Legend plates, panel nameplates, MIL-SPEC plates"
}, {
  material: "Two-color acrylic",
  bestFor: "Wide color range, fast lead time, indoor/outdoor",
  products: "Legend plates, equipment ID, signage"
}, {
  material: "Stainless steel (304/316)",
  bestFor: "Harsh, high-temp, wash-down environments",
  products: "Valve tags, equipment nameplates, cable tags"
}, {
  material: "Anodized aluminum",
  bestFor: "Outdoor, UV exposure, lightweight installs",
  products: "Nameplates, asset tags, arc flash labels"
}, {
  material: "Brass",
  bestFor: "Process ID, valves, decorative durability",
  products: "Valve tags, legacy facility tags"
}];
export default function BrowseByMaterial() {
  return <section id="browse-by-material" className="bg-background">
      <div className="bg-muted py-16 md:py-24">
        <div className="container mx-auto px-4 md:px-6">
          <div className="max-w-5xl mx-auto">
            <div className="mb-10">
              <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground mb-4">
                What Materials Are These Products Made In?
              </h2>
              <p className="text-lg text-muted-foreground max-w-3xl">
                Evermark Industrial Solutions manufactures every product family in the material the application requires — five engraving materials in all.
              </p>
            </div>

            <div className="bg-card border border-border rounded-lg shadow-sm overflow-hidden mb-8">
              <Table>
                <TableHeader>
                  <TableRow className="bg-muted/50 hover:bg-muted/50">
                    <TableHead className="w-[25%] font-semibold text-foreground py-4">
                      Material
                    </TableHead>
                    <TableHead className="w-[40%] font-semibold text-foreground py-4">
                      Best For
                    </TableHead>
                    <TableHead className="w-[35%] font-semibold text-foreground py-4">
                      Common Products
                    </TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {materialsData.map((row, i) => <TableRow key={i} data-index={i} className="hover:bg-muted/30">
                      <TableCell className="font-medium text-foreground py-4">
                        {row.material}
                      </TableCell>
                      <TableCell className="text-muted-foreground py-4">
                        {row.bestFor}
                      </TableCell>
                      <TableCell className="text-muted-foreground py-4">
                        {row.products}
                      </TableCell>
                    </TableRow>)}
                </TableBody>
              </Table>
            </div>

            
          </div>
        </div>
      </div>
    </section>;
}